import classNames from "classnames";
import { AuthService } from "shared/mechanics/auth";
import { SubscriptionPlanViewModel } from "../model/subscriptions";

import styles from './subscriptions.module.scss';

import { TextButton, ProcessingTextButton } from 'shared/ui-kit';
import { showAuthPopup } from "shared/auth";
import { useState } from "react";
import { SubscriptionService } from "api/subscription";
import { useHistory } from "react-router-dom";

export interface SubscriptionsProps {
	plans: SubscriptionPlanViewModel[];
}

const userInfo = AuthService.resolveUserInfo();


export const Subscriptions = (props: SubscriptionsProps) => {
	const history = useHistory();
	const [subscriptionPlan, setSubscriptionPlan] = useState(props.plans[0]);

	async function createInvoice() {
		try {
			const invoice = await SubscriptionService.createInvoice(subscriptionPlan.systemName);

			history.push(`/subscription/pay/${invoice.id}`);
		}
		catch {
			alert('Не удалось создать платеж, попробуйте позже')
		}
	}

	return (
		<div className={classNames(styles.container)}>
			{
				props.plans.map(plan => (
					<div key={plan.systemName} className={styles.item}>
						<input type="radio" value={plan.systemName} name="plan" checked={plan === subscriptionPlan} onChange={() => { setSubscriptionPlan(plan) }} />
						{
							plan.isBasePlan
								? (
									<span>
										<span className={styles.simple}>{ plan.period }:</span>
										<span className={styles.actualPrice}>{ plan.pricePerMonth.toFixed(0) }</span>
										<span className={styles.simple}>₽</span>
									</span>
								)
								: (
									<span>
										<span className={styles.simple}>{ plan.period }:</span>
										<span className={styles.actualPrice}>{ plan.pricePerMonth.toFixed(0) }</span>
										<span className={styles.simple}>₽/м</span>
										<span className={styles.discountPercent}>-{ plan.discountPercent.toFixed(0) }%</span>
									</span>
								)
						}
					</div>
				))
			}
			<div className={styles.buttons}>
				{
					userInfo == null
						? <TextButton title="Регистрация" onClick={() => showAuthPopup({ title: 'Подписка Инвестор+ на сервисе Rusetfs.com', showAdvantages: false }) } />
						: <ProcessingTextButton title={`Оформить за ${subscriptionPlan.priceWithDiscount} ₽`} processingMethod={createInvoice} />
				}
			</div>
			<div className={styles.help}>
				<p>
					Подробные условия в <a href="https://blog.rusetfs.com/posts/%D0%BF%D1%83%D0%B1%D0%BB%D0%B8%D1%87%D0%BD%D0%B0%D1%8F-%D0%BE%D1%84%D0%B5%D1%80%D1%82%D0%B0">публичной оферте</a>.
				</p>
				<p>
				Предупреждение: подписка предоставляет доступ к бета-тесту сервиса.
				</p>
			</div>
		</div>
	)
}